const METERS_PER_MILE = 1610
export const MAX_FRANCHISE_LOCATION_RADIUS = 90 * METERS_PER_MILE
export const MIN_FRANCHISE_LOCATION_RADIUS = 60 * METERS_PER_MILE
